import { AI_CHAT_PANEL_MAX_WIDTH, AI_CHAT_PANEL_MIN_WIDTH } from '@/features/global-ai-chat/store/globalAiChatStore';

/** パネル最大幅のビューポート幅に対する割合 */
const MAX_VIEWPORT_RATIO = 0.8;

/**
 * AI チャットパネルの幅を許容範囲に丸める。
 * 最小: AI_CHAT_PANEL_MIN_WIDTH、最大: AI_CHAT_PANEL_MAX_WIDTH とビューポート幅 80% の小さい方。
 */
export function clampAiChatPanelWidth(width: number, viewportWidth: number): number {
  const max = Math.min(AI_CHAT_PANEL_MAX_WIDTH, viewportWidth * MAX_VIEWPORT_RATIO);
  return Math.min(Math.max(width, AI_CHAT_PANEL_MIN_WIDTH), max);
}